import { bem, selectSpeakerSinkId } from '@socialive/common';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import LoadingIcon from '../../Icons/LoadingIcon';
import './video.css';

/*
#tailwind
videoPreview__player--hidePlayButton videoPreview__player--hideTimeline
*/

function Video({ src, duration, controls, controlsList, className, hideTimeline, ...other }) {
  const ref = useRef();
  const sinkId = useSelector(selectSpeakerSinkId);

  useEffect(() => {
    if (src && sinkId) {
      ref.current.setSinkId(sinkId);
    }
  }, [src, sinkId]);

  return (
    <div className={bem`videoPreview ${className}`} {...other}>
      {src ? (
        <>
          <video
            ref={ref}
            controls={controls}
            controlsList={controlsList}
            className={bem`videoPreview__player--${{ hideTimeline }}`}
            src={src}
          />
          <div className="videoPreview__duration">{duration}</div>
        </>
      ) : (
        <div className="videoPreview__placeholder">
          <LoadingIcon className="videoPreview__placeholderIcon" />
        </div>
      )}
    </div>
  );
}

Video.propTypes = {
  src: PropTypes.string,
  duration: PropTypes.string,
  className: PropTypes.string,
  controls: PropTypes.bool,
  controlsList: PropTypes.string,
  hideTimeline: PropTypes.bool,
};

Video.defaultProps = {
  src: undefined,
  duration: undefined,
  className: undefined,
  controls: false,
  controlsList: undefined,
  hideTimeline: false,
};

export default Video;
